<template>
  <div class="color-picker-panel">
    <div class="panel-row spectrum-wrp">
      <div class="spectrum-map">
        <div :id="'spectrum-cursor-' + wrapperId" class="color-cursor spectrum-cursor" />
        <canvas :id="'spectrum-canvas-' + wrapperId" class="spectrum-canvas" />
      </div>
      <div class="hue-map">
        <div :id="'hue-cursor-' + wrapperId" class="color-cursor hue-cursor" />
        <canvas :id="'hue-canvas-' + wrapperId" class="hue-canvas" />
      </div>
    </div>

    <div class="panel-row color-input-wrp">
      <div v-if="false" v-bind:key="currentMode?.seq" id="rgb-fields" class="field-group rgb-fields active">
        <!-- Mode = RGB -->
        <div>
          <label for="">R:</label>
          <input
            type="number"
            max="255"
            step="1"
            min="0"
            id="red"
            v-model="rgbColor[0]"
            @blur="onChangeColorInputHandler('rgb')"
            v-on:keyup.enter="onChangeColorInputHandler('rgb')"
            @change="rgbColor[0] = Math.max(Math.min(Math.round(rgbColor[0]), 255), 0)"
          />
        </div>
        <div>
          <label for="">G:</label>
          <input
            type="number"
            max="255"
            step="1"
            min="0"
            id="green"
            v-model="rgbColor[1]"
            @blur="onChangeColorInputHandler('rgb')"
            v-on:keyup.enter="onChangeColorInputHandler('rgb')"
            @change="rgbColor[1] = Math.max(Math.min(Math.round(rgbColor[1]), 255), 0)"
          />
        </div>
        <div>
          <label for="">B:</label>
          <input
            type="number"
            max="255"
            step="1"
            min="0"
            id="blue"
            v-model="rgbColor[2]"
            @blur="onChangeColorInputHandler('rgb')"
            v-on:keyup.enter="onChangeColorInputHandler('rgb')"
            @change="rgbColor[2] = Math.max(Math.min(Math.round(rgbColor[2]), 255), 0)"
          />
        </div>
      </div>

      <div v-bind:key="currentMode?.seq" id="hex-field" class="field-group hex-field active">
        <!-- Mode = HEX -->
        <label for="">HEX:</label>
        <input
          type="text"
          id="hex"
          :maxlength="10"
          v-model="hexWithAlpha"
          @blur="onChangeColorInputHandler('hex')"
          v-on:keyup.enter="onChangeColorInputHandler('hex')"
        />
      </div>
      <div class="tran-picker">
        <input
          type="range"
          min="0"
          max="1"
          v-model="alpha"
          step="0.01"
          class="pickerSlider"
          id="pickerSliderOpacity"
          :style="`background: linear-gradient(to right, transparent, ${hexColor.substring(0, 7)} ), repeating-linear-gradient(90deg, white, white 10px, lightgrey 10px, lightgrey 20px);`"
        />
      </div>

      <div v-if="false" v-bind:key="currentMode?.seq" id="hsl-fields" class="field-group rgb-fields active">
        <!-- Mode = HSL -->
        <div>
          <label for="">H:</label>
          <input
            type="number"
            max="360"
            step="1"
            min="0"
            id="hue"
            v-model="hslColor[0]"
            @blur="onChangeColorInputHandler('hsl')"
            v-on:keyup.enter="onChangeColorInputHandler('hsl')"
            @change="hslColor[0] = Math.max(Math.min(Math.round(hslColor[0]), 360), 0)"
          />
        </div>
        <div>
          <label for="">S:</label>
          <input
            type="number"
            max="100"
            step="1"
            min="0"
            id="sat"
            v-model="hslColor[1]"
            @blur="onChangeColorInputHandler('hsl')"
            v-on:keyup.enter="onChangeColorInputHandler('hsl')"
            @change="hslColor[1] = Math.max(Math.min(Math.round(hslColor[1]), 100), 0)"
          />
        </div>
        <div>
          <label for="">L:</label>
          <input
            type="number"
            max="50"
            step="1"
            min="0"
            id="lum"
            v-model="hslColor[2]"
            @blur="onChangeColorInputHandler('hsl')"
            v-on:keyup.enter="onChangeColorInputHandler('hsl')"
            @change="hslColor[2] = Math.max(Math.min(Math.round(hslColor[2]), 50), 0)"
          />
        </div>
      </div>
      <!-- <button id="mode-toggle" class="btn-dark btn mode-toggle" @click="modeToggleHandler">Mode</button> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import useColorSpectrum from './hooks/useColorSpectrum';

interface Props {
  currentColor?: string;
  wrapperId: string;
}

const props = defineProps<Props>();

const { rgbColor, styleRangeColor, hexColor, hexWithAlpha, alpha, hslColor, currentMode, onChangeColorInputHandler, modeToggleHandler } =
  useColorSpectrum(props);
</script>

<style scoped lang="scss">
@import '@/assets/styles/base/base-color-spectrum.scss';
.pickerSlider {
  -webkit-appearance: none;
  appearance: none;
  width: 50%;
  height: 10px;
  border-radius: 5px;
  background: lightgrey;
  outline: none;
}

.pickerSlider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  height: 20px;
  width: 20px;
  background: radial-gradient(rgba(255, 255, 255, 0) 30%, rgba(0, 0, 0, 1));
  border: solid 2px rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  box-sizing: content-box;
}

.pickerSlider::-moz-range-thumb {
  cursor: pointer;
  height: 20px;
  width: 20px;
  background: radial-gradient(rgba(255, 255, 255, 0) 30%, rgba(0, 0, 0, 1));
  border: solid 2px rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  box-sizing: content-box;
}
#pickerSliderOpacity {
  padding: 0rem 0rem;
  background: linear-gradient(to right, transparent, rgb(0, 0, 0)),
    repeating-linear-gradient(90deg, white, white 10px, lightgrey 10px, lightgrey 20px);
}
</style>
